<template>
  <div class="show-detail-container" v-if="visible">
    <el-dialog :title="$t('text.regionInspection')" :visible.sync="boxVisible" :close-on-click-modal="false" :before-close="cancel">
      <div class="custom-list">
        <el-table
                  :data="regionListData"
                  :max-height="300"
                  v-loading="refreshloading"
                  class="product-table"
                  :empty-text="tableEmptyTip">
              <el-table-column prop="checkTime" min-width="200" :label="$t('text.inspectionDate')" :formatter="maybeEmpty"></el-table-column>
              <el-table-column prop="temperature"  min-width="150" :label="$t('text.temperatureValue')" :formatter="maybeEmpty"></el-table-column>
              <el-table-column prop="humidity"  min-width="150" :label="$t('text.humidityValue')" :formatter="maybeEmpty"></el-table-column>
              <el-table-column prop="goodsPlacementName" min-width="100"  :label="$t('text.arrangementOfArticles')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.goodsPlacement == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.goodsPlacementName}}</span>
                </template>

              </el-table-column>
              <el-table-column prop="leakWaterName"  min-width="100" :label="$t('text.waterLeakage')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.leakWater == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.leakWaterName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="accessControlName" min-width="100"  :label="$t('text.accessControl')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.accessControl == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.accessControlName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="monitorName" min-width="100"  :label="$t('text.securityMonitoring')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.monitor == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.monitorName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="fireName"  min-width="100" :label="$t('text.fireProtection')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.fire == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.fireName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="thunderName"  min-width="100" :label="$t('text.lightningProtection')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.thunder == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.thunderName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="airConditioningName"  min-width="100" :label="$t('text.airConditioning')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.airConditioning == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.airConditioningName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="powerName"  min-width="100" :label="$t('text.powerSupply')" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.power == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.powerName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="upsName" label="UPS"  min-width="100" :formatter="maybeEmpty">
                <template slot-scope="scope">
                  <span :class="scope.row.ups == 'abnormal' ? 'jc-status jc-status--red':'jc-status jc-status--green'">{{scope.row.upsName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="physicalEnv"  min-width="200" :label="$t('text.physicalEnvAbnormality')" :formatter="maybeEmpty"></el-table-column>

            </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{$t('text.cancel')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'ShowDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object
    }
  },
  data() {
    return {
      boxVisible: this.visible,
      refreshloading: false,
      regionListData: [],
      tableEmptyTip: this.$t('text.noSearch'),
    };
  },
  created() {
    this.getRegionList();
  },
  watch: {
    visible(newVal, oldVal) {
      this.boxVisible = newVal;
    }
  },
  methods: {
    maybeEmpty (row, column) {
      const arr = row[column.property];
      const sign = '--';
      return arr || sign;
    },
    cancel() {
      this.$emit('update:visible', false);
    },
    getRegionList () {
      this.refreshloading = true;
      const params = {
        checkDate: this.detailData.checkDate,
        idc: this.detailData.idc
      };
      this.$api.getIdcInspectionDetail(params).then((response) => {
        this.total = response.data.totalCount;
        this.refreshloading = false;
        if (response.data.idcInspection.length === 1 && response.data.idcInspection[0] === null) {
          this.regionListData = [];
        } else {
          this.regionListData = cloneDeep(response.data.idcInspection);
        }
      }).finally(() => {
        this.refreshloading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.show-detail-container /deep/ .el-table__body-wrapper {
  overflow: auto !important;
}
.normal-color{
    color:#008000;
  }
  .abnormal-color{
    color:#ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/components/inspection/region/showDetail.vue